/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EmbeddedResource } from './embeddedResource';
import { Link } from './link';
import { MarGroup } from './marGroup';
import { NursingStation } from './nursingStation';
import { ReportResident } from './reportResident';


export interface MedicalRecordOptions { 
    /**
     * Type of report: ex. MarTar, POS
     */
    MedicalRecord?: MedicalRecordOptions.MedicalRecordEnum;
    /**
     * Sort order
     */
    sortOrder?: MedicalRecordOptions.SortOrderEnum;
    /**
     * Facility name
     */
    FacilityName?: string;
    /**
     * Facility Org Unit ID
     */
    OrgUnitId?: string;
    /**
     * Residents to generate the report for
     */
    Residents?: Array<ReportResident>;
    /**
     * Nursing Station to be used
     */
    NursingStations?: Array<NursingStation>;
    /**
     * MAR/TAR groups
     */
    MarGroups?: Array<MarGroup>;
    StartDate?: Date;
    EndDate?: Date;
    /**
     * Admissions Start date for report
     */
    readonly AdmissionStartDate?: string;
    /**
     * Admissions End date for report
     */
    readonly AdmissionEndDate?: string;
    /**
     * General report options
     */
    ReportOptions?: Array<MarGroup>;
    /**
     * Id of the object if there is one.  Some summary screens will not populate this value
     */
    Id?: string;
    _links?: Array<Link>;
    _embedded?: Array<EmbeddedResource>;
}
export namespace MedicalRecordOptions {
    export type MedicalRecordEnum = 'NoneSelected' | 'Mar' | 'Tar' | 'MarTar' | 'BlankForms' | 'POS';
    export const MedicalRecordEnum = {
        NoneSelected: 'NoneSelected' as MedicalRecordEnum,
        Mar: 'Mar' as MedicalRecordEnum,
        Tar: 'Tar' as MedicalRecordEnum,
        MarTar: 'MarTar' as MedicalRecordEnum,
        BlankForms: 'BlankForms' as MedicalRecordEnum,
        POS: 'POS' as MedicalRecordEnum
    };
    export type SortOrderEnum = 'ResidentName' | 'NursingStationResidentName' | 'NursingStationRoomBed' | 'RoomBed';
    export const SortOrderEnum = {
        ResidentName: 'ResidentName' as SortOrderEnum,
        NursingStationResidentName: 'NursingStationResidentName' as SortOrderEnum,
        NursingStationRoomBed: 'NursingStationRoomBed' as SortOrderEnum,
        RoomBed: 'RoomBed' as SortOrderEnum
    };
}
